import { useMemo } from 'react';

/**
 * Calculates the total nested albums for each albumFolder within a given albumFolder tree.
 * TODO: Keep an eye here for performance.
 *
 * @param {Object} albumFolderTree The albumFolder tree.
 * @returns {Object} Object where keys are the albumFolders' ids, and the value is the total albums.
 */
const useAlbumFolderAlbumsTotal = albumFolderTree => {
  const albumFolderAlbumsTotal = useMemo(() => {
    const albumTotals = {};

    const getAlbumFolderAlbumsTotal = albumFolder => {
      const albumFolderChildrenAlbumsTotal =
        albumFolder.children?.albums?.total ??
        albumFolder.children?.albums?.records.length ??
        0;

      const albumFolderChildrenAlbumFoldersRecords =
        albumFolder.children?.album_folders?.records ?? [];

      albumTotals[albumFolder.id] =
        albumFolderChildrenAlbumFoldersRecords.reduce(
          (total, currentAlbumFolder) => {
            const currentAlbumFolderTotalAlbums =
              getAlbumFolderAlbumsTotal(currentAlbumFolder);

            return total + currentAlbumFolderTotalAlbums;
          },

          albumFolderChildrenAlbumsTotal,
        );

      return albumTotals[albumFolder.id];
    };

    getAlbumFolderAlbumsTotal(albumFolderTree);

    return albumTotals;
  }, [albumFolderTree.id]);

  return albumFolderAlbumsTotal;
};

export default useAlbumFolderAlbumsTotal;
